module.exports = __webpack_public_path__ + "img/tvbox2.830b9c8f.png";